import React from 'react';

import { Box, Typography } from '@mui/material';

type Props = {
  children: JsxNode;
};

export default function TemplateEventField({ children }: Props) {
  return (
    <Box p={2}>
      <Typography fontStyle="italic" color="text.secondary">
        {children}
      </Typography>
    </Box>
  );
}
